import { render } from "./ReadArtikel.vue?vue&type=template&id=22a09a7e"
import script from "./ReadArtikel.vue?vue&type=script&lang=js"
export * from "./ReadArtikel.vue?vue&type=script&lang=js"

import "./ReadArtikel.vue?vue&type=style&index=0&id=22a09a7e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__